import React, { useRef, useState, useEffect } from "react";

export default function NumberInput(props) {
  const { min, max, defaultNum, className, id, setValue, value } = props;

  const numberInputRef = useRef(null);
  const inputCopyRef = useRef(null);
  const [inputWidth, setInputWidth] = useState("30px");

  useEffect(() => {
    inputCopyRef.current && setInputWidth(inputCopyRef.current.offsetWidth + 2);
  }, [value]);

  function handleNumberInputChange(event) {
    const value = event.target.value;
    if (value === "") {
      setValue("");
      return;
    }
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= min && numValue <= max) {
      setValue(numValue.toString());
    }
  }

  function incrementNumberInput(num) {
    const total = num + parseInt(value);
    if (total > max) {
      setValue(max);
    } else if (total < min) {
      setValue(min);
    } else {
      setValue(total);
    }
  }

  function handleNumberInputKeyDown(event) {
    if (event.key === "Enter") {
      numberInputRef.current.blur();
    }
    if (event.key === "ArrowDown") {
      event.preventDefault();
      incrementNumberInput(-1);
    }
    if (event.key === "ArrowUp") {
      event.preventDefault();
      incrementNumberInput(1);
    }
  }

  function handleNumberInputBlur() {
    if (value === "") {
      setValue(defaultNum);
    }
  }

  return (
    <div
      className="number-input-container"
      style={{ "max-width": inputWidth, overflow: "hidden", display: "flex" }}
    >
      <input
        className={className}
        id={id}
        style={{ width: inputWidth }}
        ref={numberInputRef}
        onChange={handleNumberInputChange}
        onKeyDown={handleNumberInputKeyDown}
        onBlur={handleNumberInputBlur}
        value={value}
      />
      <span ref={inputCopyRef} className="time-input-copy digits">
        {value}
      </span>
    </div>
  );
}
